import { useEffect } from 'react';

export const useAboutTemplate = () => {
  useEffect(() => {
    // 1. Initialize WOW.js (Scroll animations)
    if (window.WOW) {
      new window.WOW().init();
    }

    // 2. Initialize Splitting.js (Text splitting)
    if (window.Splitting) {
      window.Splitting();
    }

    // 3. Initialize Odometer/Appear (Counters)
    // Most templates use 'appear.js' to trigger the count-up
    if (window.$ && window.$.fn.appear) {
      window.$('.count-box').appear(function() {
        const $this = window.$(this);
        const Stop = $this.find('.count-text').attr('data-stop');
        const Speed = $this.find('.count-text').attr('data-speed');
        
        if (!$this.hasClass('counted')) {
          $this.addClass('counted');
          window.$({ countNum: 0 }).animate(
            { countNum: Stop },
            {
              duration: parseInt(Speed) || 2000,
              easing: 'linear',
              step: function() {
                $this.find('.count-text').text(Math.floor(this.countNum));
              },
              complete: function() {
                $this.find('.count-text').text(this.countNum);
              }
            }
          );
        }
      });
    }

    // 4. GSAP / SplitText Refresh
    // Since you have GSAP and ScrollTrigger scripts loaded
    if (window.ScrollTrigger) {
      window.ScrollTrigger.refresh();
    }

    // 5. FIX: Initialize Dropdowns/Selects
    // Most jQuery templates use 'niceSelect' for the contact form dropdowns
    if (window.$ && window.$.fn.niceSelect) {
      window.$('select').niceSelect();
    }

    // Cleanup (Optional but good practice)
    return () => {
      // If you need to destroy specific instances to save memory
    };
  }, []);
};